import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import { allUserDraftsAtom, currentProjectDraftsAtom } from 'atoms';
import { useGetCompanyRolePermissionsMeQuery } from 'redux-store/api/company-roles';
import { useGetProjectsQuery } from 'redux-store/api/projects';
import { DraftButtonWithDialog } from './components/draft-button-with-dialog';

export const Drafts = () => {
  const { data: userPermissions } = useGetCompanyRolePermissionsMeQuery();
  const hasAccess = userPermissions?.ENABLE_ACTIVITY_FEED?.canRead;

  const location = useLocation();
  const isInsideProject = location.pathname.includes('/project-dashboard/');

  const allDrafts = useAtomValue(allUserDraftsAtom);
  const projectDrafts = useAtomValue(currentProjectDraftsAtom);
  const { data: projectsList } = useGetProjectsQuery({});

  const activeProjectIds = useMemo(() => {
    if (!projectsList?.items) return new Set<number>();
    return new Set(projectsList.items.map((p) => p.id));
  }, [projectsList?.items]);

  const drafts = useMemo(() => {
    if (isInsideProject) return projectDrafts;

    const filtered = allDrafts.filter(
      (d) =>
        !d.media?.some((m) => m.url === '') &&
        (activeProjectIds.size === 0 || activeProjectIds.has(Number(d.projectId))),
    );
    const projectOrder = new Map<string, number>();
    filtered.forEach((d, i) => {
      const pid = d.projectId || '';
      if (!projectOrder.has(pid)) projectOrder.set(pid, i);
    });
    return [...filtered].sort((a, b) => {
      const aOrder = projectOrder.get(a.projectId || '') ?? 0;
      const bOrder = projectOrder.get(b.projectId || '') ?? 0;
      return aOrder - bOrder;
    });
  }, [isInsideProject, projectDrafts, allDrafts, activeProjectIds]);

  if (!drafts.length || !hasAccess) return null;

  return <DraftButtonWithDialog drafts={drafts} />;
};
